import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  from,
  ApolloLink,
  // ApolloLink,
} from "@apollo/client";
import { GQL_URL } from "../../config/global";
import {
  getEnv,
  getToken,
  getUserId,
  hasToken,
} from "../TokenHelper";

const httpLink = new HttpLink({
  uri: GQL_URL,
  credentials: "include",
});

const AddToken = new ApolloLink(
  (operation, forward) => {
    // if (hasToken()) {
      operation.setContext(
        ({ headers = {} }) => ({
          headers: {
            ...headers,
            Authorization: `${getToken() || ""}`,
            Env: `${getEnv()}`,
            uid: `${getUserId() || ""}`,
          },
        })
      );
    // }
    return forward(operation);
  }
);

export const client = new ApolloClient({
  link: from([
    // RefreshToken,
    AddToken,
    httpLink as any,
  ]),
  credentials: "include",
  cache: new InMemoryCache(),
});
